import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ShieldCheck, ExternalLink } from 'lucide-react';

const MAIN_PHONE = '04 70 42 72 63';
const MAIN_EMAIL = 'ambulancesbeaulon@live.fr';

export default function Footer() {
  return (
    <footer className="mt-12 border-t bg-anthracite-950 text-white">
      <div className="container-app py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700 flex items-center justify-center shadow-lg shadow-brand-700/30 ring-1 ring-white/10">
                <span className="text-white font-heading font-bold text-2xl">B</span>
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-semibold text-white/90 text-lg tracking-tight">Groupe Ambulances</span>
                <span className="font-heading font-extrabold text-white text-xl tracking-tight -mt-0.5">Beaulon</span>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              Transport sanitaire de proximité dans l'Allier.
            </p>
            <ul className="mt-3 space-y-1.5 text-xs text-white/60">
              <li className="flex items-center gap-2"><span className="h-1 w-1 rounded-full bg-brand-300"></span> Ambulance Beaulon</li>
              <li className="flex items-center gap-2"><span className="h-1 w-1 rounded-full bg-brand-300"></span> Ambulance 03 Avermes Saint-Ennemond</li>
            </ul>
          </div>

          {/* Liens */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-3">Le groupe</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/le-groupe" className="hover:text-white">Notre histoire</Link></li>
              <li><Link to="/implantations" className="hover:text-white">Implantations</Link></li>
              <li><Link to="/flotte" className="hover:text-white">Notre flotte</Link></li>
              <li><Link to="/recrutement" className="hover:text-white">Recrutement</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-3">Services</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/services" className="hover:text-white">Tous nos services</Link></li>
              <li><Link to="/transports-specialises" className="hover:text-white">Transports spécialisés</Link></li>
              <li><Link to="/devis" className="hover:text-white">Demande de devis</Link></li>
              <li><Link to="/estimation-taxi" className="hover:text-white">Estimation taxi</Link></li>
              <li><Link to="/avis" className="hover:text-white">Avis clients</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-3">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-0.5 text-brand-300 shrink-0" />
                <a href={`tel:${MAIN_PHONE.replace(/\s/g, '')}`} className="hover:text-white" data-testid="footer-phone-link">{MAIN_PHONE}</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-0.5 text-brand-300 shrink-0" />
                <a href={`mailto:${MAIN_EMAIL}`} className="hover:text-white break-all" data-testid="footer-email-link">{MAIN_EMAIL}</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-brand-300 shrink-0" />
                <span>Département de l'Allier (03)</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="h-4 w-4 mt-0.5 text-brand-300 shrink-0" />
                <span>Disponible toute l'année selon planning</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-white/60">
            <ShieldCheck className="h-4 w-4 text-brand-300" />
            © {new Date().getFullYear()} Groupe Ambulances Beaulon. Tous droits réservés.
          </div>
          <div className="flex items-center gap-4 text-xs text-white/50">
            <Link to="/contact" className="hover:text-white">Mentions légales</Link>
            <Link to="/contact" className="hover:text-white">RGPD</Link>
            <Link to="/admin/login" className="hover:text-white inline-flex items-center gap-1">Espace admin <ExternalLink className="h-3 w-3" /></Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
